<template>
  <div class="time-line">
    <p class="page-title">타임라인</p>

    <div v-if="isReady">
      <ul class="team-info">
        <li class="emblem">
          <img :src="getEmblem(info.home_team)" alt="">
          <p>{{info.home_team_goal}}</p>
        </li>
        <li class="center-div">
          <div><p>경기종료</p></div>
        </li>
        <li class="emblem">
          <p>{{info.away_team_goal}}</p>
          <img :src="getEmblem(info.away_team)" alt="">
        </li>
      </ul>

      <div class="time-line-border"></div>

      <div v-if="isReady">
        <div v-for="(item, index) in timeLineList" :key="index">
          <ul class="time-line-item">
            <li class="left" style="grid-area: lt;" v-if="item.division === 'H'">
              <div :class="item.type">
                <p class="first" :class="{red: item.red, yellow: item.yellow}">{{item.player_info}}</p>
                <p v-if="item.play_status === '득점' || item.play_status === '교체'" class="second">
                <span :class="{hidden: !item.add_info_name}">
                  {{item.add_info_name ? item.add_info_name : ''}}
                </span>
                  <span v-if="item.play_status === '득점' && item.add_info_name">&nbsp;도움</span>
                  <span v-if="item.add_info === 'PK'">&nbsp;PK</span>
                </p>
              </div>
            </li>
            <!-- 중앙 : 경기 종료일 때 'end' Class 추가 -->
            <li class="center-div" :class="{end: item.matchEnd}" style="grid-area: ct;">
              <div><p>{{item.play_time}}</p></div>
            </li>
            <!-- -->
            <li class="right" style="grid-area: rt;" v-if="item.division === 'A'">
              <div :class="item.type">
                <p class="first" :class="{red: item.red, yellow: item.yellow}">{{item.player_info}}</p>
                <p v-if="item.play_status === '득점' || item.play_status === '교체'" class="second">
                <span :class="{hidden: !item.add_info_name}">
                  {{item.add_info_name ? item.add_info_name : ''}}
                </span>
                  <span v-if="item.play_status === '득점' && item.add_info_name">&nbsp;도움</span>
                  <span v-if="item.add_info === 'PK'">&nbsp;PK</span>
                </p>
              </div>
            </li>
          </ul>
          <div class="time-line-border"></div>
        </div>
      </div>
      <div v-else class="noData">
        해당 경기의 타임라인 기록이 없습니다.
      </div>

      <div class="time-line-start">
        <p>시작</p>
      </div>
    </div>
    <MatchNotFound v-else :title="'경기 기록'" />

  </div>
</template>

<!--
.time-line-item > li.center-div
중앙 : 경기 종료일 때 'end' Class 추가

.time-line-item > li
선수 교체 : div class='in-out'
카드 : div class='card-div'
  - 하위 : 레드(red), 옐로우(yellow)
-->

<script>
import {getEmblem, isEmpty} from '@/lib';
import MatchNotFound from '@/components/Ticket/MatchNotFound.vue';

export default {
  name: 'MatchTimeLines',
  components: {MatchNotFound},
  props: {
    game: {
      type: Object,
      default: () => {
        return {}
      }
    },
    timeline: {
      type: Array,
      default: () => {
        return []
      }
    },
    isReady: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    game: {
      handler: function () {
        this.info = this.game;
      },
      deep: true
    },
    timeline: {
      handler: function () {
        if(this.setStatus) {
          this.setStatus = false;
          this.setTimeLine();
        }
      },
      deep: true
    }
  },
  data() {
    return {
      info: {},
      timeLineList: [],
      setStatus: true
    }
  },
  mounted () {
    // this.setTimeLine();
    this.info = this.game;
  },
  methods: {
    isEmpty,
    getEmblem,
    setTimeLine() {

      this.timeLineList = [];
      let endStatus = {
        first: true,
        second: true
      }
      const timelineData = [...this.timeline];
      timelineData.map((item, ) => {
        item.player_info = item.player_info.replace(/[0-9]/g, '');

        if(item.player_info.includes('코치')) {
          item.player_info = this.addTextSpace(item.player_info, '코치');
        }

        if(item.player_info.includes('감독')) {
          item.player_info = this.addTextSpace(item.player_info, '감독');
        }

        if (item.play_status === '득점' || item.play_status === '페널티킥 실축') {
          item.type = 'goal-div';
        } else if (item.play_status === '교체') {
          item.type = 'in-out';
        } else {
          item.type = 'card-div';
        }

        if(item.play_status === '경고') {
          item.yellow = true;
        } else if(item.play_status === '경고 누적 퇴장' || item.play_status === '퇴장') {
          item.red = true;
        }

        if (item.play_half === '전반') {
          if(Number(item.play_time) === 45 && endStatus.first) {
            endStatus.first = false;
            item.matchEnd = true;
          } else if(Number(item.play_time) > 45) {
            if(endStatus.first) {
              endStatus.first = false;
              const obj = { matchEnd: true, play_time: '45' }
              this.timeLineList.unshift(obj);
            }

            item.play_time = `+${Number(item.play_time) - 45}`;
          }
        }

        if(item.play_half === '후반') {
          item.play_time = Number(item.play_time) + 45;
          if(endStatus.first) {
            endStatus.first = false;
            const obj = {
              matchEnd: true,
              play_time: '45'
            }
            this.timeLineList.unshift(obj);
          }

          if (Number(item.play_time) === 90 && endStatus.second) {
            endStatus.second = false;
            item.matchEnd = true;
          } else if (Number(item.play_time) > 90) {
            if(endStatus.second) {
              endStatus.second = false;
              const obj = {
                matchEnd: true,
                play_time: '90'
              }
              this.timeLineList.unshift(obj);
            }
            item.play_time = `+${Number(item.play_time) - 90}`;
          }
        }
        this.timeLineList.unshift(item);
      })

      if (endStatus.second) {
        endStatus.second = false;
        const obj = {
          matchEnd: true,
          play_time: '90'
        }
        this.timeLineList.unshift(obj);
      }
    },
    addTextSpace(text, division) {
      text = text.split(' ').join('');
      const words = text.split(division);
      const str = words[0] + division + ' ' + words[1];
      return str;
    }
  },
}
</script>
<style scoped>
.noData {
  text-align: center;
  padding: 20px 0;
  font-size: 14px;
  color: #999;
}
</style>
